import snsWebSdk from '@sumsub/websdk';
import type { EventPayload } from '@sumsub/websdk/types/types';

export interface useSumsubProps {
  token: string;
  getNewAccessToken: () => Promise<string>;
  containerId?: string;
  onReady?: () => void;
  onComplete?: () => void;
  onError?: (err: unknown) => void;
}

export default function useSumsub() {
  // const colorMode = useColorMode();
  const locale = useLocaleUtils();
  const siteStore = useSiteStore();

  const initialise = ({
    token,
    getNewAccessToken,
    containerId = '#sumsub-websdk-container',
    onReady,
    onError,
    onComplete,
  }: useSumsubProps): void => {
    const snsWebSdkInstance = snsWebSdk
      .init(token, () => getNewAccessToken())
      .withConf({
        lang: locale.getLocale().split('-')[0],
        // theme: colorMode.preference,
        theme: 'dark',
        country: siteStore.config.countries[0]?.countryIsoThree,
      })
      .withOptions({
        addViewportTag: false,
        adaptIframeHeight: true,
        debug: true,
      })
      .on('idCheck.onReady', onReady)
      .on('idCheck.onError', onError)
      .on('idCheck.onActionCompleted', onComplete)
      .on('idCheck.onResize', (payload) => {
        const el = document.getElementById(containerId);
        if (!!el) el.style.minHeight = `${payload?.height}px`;
      })
      .onMessage((type, payload) => {
        if (type === 'idCheck.onApplicantStatusChanged') {
          if (
            (payload as EventPayload<'idCheck.onApplicantStatusChanged'>)
              ?.reviewStatus === 'completed' &&
            (payload as EventPayload<'idCheck.onApplicantStatusChanged'>)
              ?.reviewResult?.reviewAnswer === 'GREEN'
          )
            onComplete();
        }
        if (type === 'idCheck.onApplicantActionStatusChanged')
          if (
            (payload as EventPayload<'idCheck.onApplicantActionStatusChanged'>)
              ?.reviewStatus === 'completed' &&
            (payload as EventPayload<'idCheck.onApplicantActionStatusChanged'>)
              ?.reviewResult.reviewAnswer === 'GREEN'
          )
            onComplete();
      })
      .build();

    snsWebSdkInstance.launch('#sumsub-websdk-container');
  };

  return { initialise };
}
